<div class="modal-header border-bottom-0 px-4 pt-4 pb-3">
                <h5 *ngIf="!reUpload" class="text-xmd text-black bold m-0"> FILE UPLOAD</h5>
                <h5 *ngIf="reUpload" class="text-xmd text-black bold m-0"> RE UPLOAD FILE</h5>
                    <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
                         <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div *ngIf="!reUpload" class="col-lg-6 col-md-6 float-left">
                    <div class="form-group w-100 float-left">
                    <label for="recordFormat">Data Source</label>
                     <select class="form-control light-bg" (change)="selectDataSource($event)">
                        <option value='none'>None</option>
                        <option [attr.selected]="selectedDataSource == datasource.id ? true : null" *ngFor="let datasource of dataSourceList" [attr.value]='datasource.id' >{{datasource.name}}</option>
                     </select>
                    </div>
                </div>
                    <input type='file' class="mt-4 ml-2" #fileHolder  multipart=true name="file" (change)="fileChange($event)"/>
                <div class="modal-footer border-top-0 p-4">
                    <button [disabled]="saveButton" class="btn btn-primary" (click)="saveFile()">Save</button>
                </div>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/fileUploadModal.ts.FileUploader.html